<div class="tasks-dashboard-page" fxLayout="column">
    <div
        class="tasks-dashboard-bg"
        [style.background-image]="backgroundImageStyle"
        [style.background-color]="backgroundImageStyle ? null : 'var(--surface-base)'"
        [style.opacity]="backgroundImageStyle ? (bgImageOpacityPct / 100) : 1"></div>
    <div class="tasks-dashboard-content" fxLayout="column">
        <div class="row">
            <div class="col-12">
                <div class="" [style.--dashboard-card-bg]="dashboardCardBackground" fxLayout="column">
                    <div class="tasks-dashboard-toolbar" fxLayout="row wrap" fxLayoutAlign="space-between center">
                        <div class="tasks-dashboard-toolbar__group" fxLayout="row wrap" fxLayoutAlign="start center">
                            <div class="searchbox">
                                <i-feather name="search"></i-feather>
                                <input 
                                    id="txtSearchQuery" 
                                    type="text" 
                                    [placeholder]="'SEARCH' | translate" 
                                    class="form-control form-control-sm ms-2" 
                                    aria-controls="tickets-table" 
                                    [(ngModel)]="searchString" 
                                    (keydown.enter)="doSearch($event)">
                            </div>
                            <div class="dropdown">
                                <ng-select 
                                    [placeholder]="'FILTER_BY_USER' | translate" 
                                    [items]="allUsers" 
                                    bindLabel="fullName" 
                                    bindValue="id" 
                                    [(ngModel)]="selectedUserId" 
                                    (ngModelChange)="filterByUser(selectedUserId)" 
                                    (clear)="filterByUser(null)" 
                                    [clearable]="true">
                                </ng-select>
                            </div>
                            <div class="dropdown">
                                <ng-select 
                                    [placeholder]="'FILTER_BY_AUTOMATION' | translate" 
                                    [items]="automationsList" 
                                    bindLabel="name" 
                                    bindValue="id" 
                                    [(ngModel)]="selectedAutomationId" 
                                    (ngModelChange)="filterByAutomation(selectedAutomationId)" 
                                    (clear)="filterByAutomation(null)" 
                                    [clearable]="true">
                                </ng-select>
                            </div>
                            <button type="button" class="gray-button tasks-dashboard-toolbar__button" (click)="toggleWeekView()">
                                {{ (showNextWeek ? 'VIEW_THIS_WEEK' : 'VIEW_NEXT_WEEK') | translate }}
                            </button>
                        </div>
                        <div class="tasks-dashboard-toolbar__group tasks-dashboard-toolbar__group--actions" fxLayout="row wrap" fxLayoutAlign="end center">
                            <button type="button" class="blue-button tasks-dashboard-toolbar__button" (click)="onAddTaskClick('add')">{{ 'ADD_TASK' | translate }}</button>
                        </div>
                    </div>

                    <div class="row" *ngIf="showNextWeek">
                        <div class="alert alert-danger tasks-dashboard-alert" role="alert">
                            <h3 class="tasks-dashboard-alert__title">{{ 'NEXT_WEEK' | translate }}</h3>
                        </div>
                    </div>
                    
                    <div class="row taskrow">
                        <div class="col task-column" [style.background-color]="dashboardColumnBackground" fxLayout="column">
                            <div class="taskHeader" [style.color]="dashboardHeaderColor">{{ 'OVERDUE' | translate }} ({{ overdueTasksData.length }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of overdueTasksData" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col task-column" [style.background-color]="dashboardColumnBackground" *ngFor="let day of weekDays" fxLayout="column">
                            <div class="taskHeader" [style.color]="dashboardHeaderColor">{{ day.key | translate }} ({{ getTaskCountForDay(day.dayIndex) }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of thisWeekTasksData" [ngClass]="{'d-none': !isTaskDueOnDay(task.dueDate, day.dayIndex)}" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col task-column" [style.background-color]="dashboardColumnBackground" fxLayout="column">
                            <div class="taskHeader" [style.color]="dashboardHeaderColor">{{ 'FUTURE' | translate }} ({{ futureTasksData.length }})</div>
                            <div class="taskcol">
                                <ul>
                                    <li *ngFor="let task of futureTasksData" (click)="viewTask(task)">
                                        <div class="title">{{ task.title }}</div>
                                        <div *ngIf="task.clientName && task.clientName > ''" class="client">{{ task.clientName }} <a target="_blank" href="/pages/client-details/{{ task.clientId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div *ngIf="task.campaignName && task.campaignName > ''" class="campaign">{{ task.campaignName }} <a target="_blank" href="/pages/campaign-details/{{ task.campaignId}}"><i class="fas fa-external-link-alt"></i></a></div>
                                        <div class="small user" *ngIf="!myTasks">{{ task.assignedUserName }}</div>
                                        <div class="small date" [ngClass]="{'overdue': isOverdue(task.dueDate)}">{{ task.dueDate | date: 'mediumDate' }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> <!-- end col -->
            </div> <!-- end row -->
        </div>
    </div>
</div>
